<template>
  <div class="text-white">
    <div
      class="rounded-sm py-0.5 px-1.5 text-xs font-bold uppercase text-ontick-carbon-900 dark:text-white"
      v-if="required_plan === 'TRIAL'"
    >
      Trial
    </div>
    <div
      class="rounded-sm bg-ontick-steel-400 py-0.5 px-1.5 text-xs uppercase"
      v-else-if="required_plan === 'BASIC'"
    >
      Basic
    </div>
    <div
      class="rounded-sm bg-ontick-teal-500 py-0.5 px-1.5 text-xs uppercase"
      v-else-if="required_plan === 'PRO'"
    >
      Pro
    </div>
    <div
      class="rounded-sm bg-ontick-prussian-200 py-0.5 px-1.5 text-xs uppercase"
      v-else-if="required_plan === 'EXPERT'"
    >
      Expert
    </div>
    <div
      class="rounded-sm bg-ontick-orange-700 py-0.5 px-1.5 text-xs font-bold uppercase"
      v-else-if="required_plan === 'EXPERT+'"
    >
      Expert+
    </div>
    <div
      class="flex items-center rounded-sm py-0.5 px-1.5 text-xs text-ontick-steel-500 dark:text-ontick-graphite-200"
      v-else-if="show_price"
    >
      <span
        class="text-sm font-bold text-ontick-carbon-900 dark:text-gray-300"
        >{{ price | currency }}</span
      ><span>/mês</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    required_plan: {
      type: String,
    },
    price: {
      type: Number,
    },
    show_price: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style></style>
